import moment from 'moment-timezone';

import { dateFormat, dateTimeFormatWithTimezone } from '../../constants/apiDateFormat';

/**
 * Get end of day (23:59:59.999) in specified timezone
 */
export const getEndOfDayInTz = (date: string, timezone: string): string =>
  moment.tz(date, dateFormat, timezone).endOf('day').format(dateTimeFormatWithTimezone);
